// Kept outside App.js so the flag can be tested without importing every route.
export const isProbateSignupRouteEnabled = () => window.appConfig?.probate_signup_enabled === true;

// Where a client who wants to change an answer starts again. The links to it
// are plain anchors, not router Links: a router navigation from the resumed
// quote page would reconcile the same route element, keep the fetched signup
// in state and change initialStepSlug after mount, which StepFlowNavigate
// reports and ignores. A full page load is what puts the flow back at the start.
export const SIGNUP_PATH = "/probate/signup";
